module.exports = __webpack_public_path__ + "static/media/banner-compliance.e50a54d0.jpg";